"use client";

import { motion } from "framer-motion";
import Header from "@/components/header";
import Footer from "@/components/footer";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { PageTitle } from "@/components/ui/page-header";
import { containerVariants, itemVariants } from "@/lib/animation-variants";
import { Mail, Phone, MapPin } from "lucide-react";

export default function ContactPage() {
  return (
    <div className="flex min-h-screen flex-col bg-gothia-green">
      <Header />

      <main className="flex-1">
        <section className="px-4 pb-16 pt-8 sm:px-6 lg:px-8">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="mx-auto max-w-4xl">
            <div className="mb-8 text-center">
              <PageTitle title="Kontakt" />
            </div>

            <motion.div variants={containerVariants} className="space-y-6">
              <motion.div variants={itemVariants}>
                <Card variant="default" title="Kontaktinformationen">
                  <CardHeader />
                  <CardContent>
                    <p className="mb-6 text-body-sm text-gray-700">
                      Du hast Fragen zum 150. Stiftungsfest oder benötigst Hilfe? Wir sind gerne für dich da!
                    </p>
                    <div className="space-y-4">
                      <a
                        href="mailto:organisation@gothia150.de"
                        className="flex items-center gap-3 text-body-sm text-gothia-green transition-colors hover:text-gothia-gold">
                        <Mail className="h-5 w-5 shrink-0" />
                        <div className="flex flex-col">
                          <span className="font-semibold">E-Mail</span>
                          <span>organisation@gothia150.de</span>
                        </div>
                      </a>
                      <a
                        href="tel:05117010289"
                        className="flex items-center gap-3 text-body-sm text-gothia-green transition-colors hover:text-gothia-gold">
                        <Phone className="h-5 w-5 shrink-0" />
                        <div className="flex flex-col">
                          <span className="font-semibold">Telefon</span>
                          <span>0511 70 10 289</span>
                          <span className="text-xs text-gray-600">Gothenhaus</span>
                        </div>
                      </a>
                      <div className="flex items-start gap-3 text-body-sm text-gray-700">
                        <MapPin className="h-5 w-5 shrink-0 mt-0.5" />
                        <div className="flex flex-col">
                          <span className="font-semibold">Adresse</span>
                          <span>AV Gothia</span>
                          <span>Wilhelm-Busch-Straße 24</span>
                          <span>30167 Hannover</span>
                          <span>Deutschland</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            </motion.div>
          </motion.div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
